// @ts-nocheck
import * as React from "react";
import * as AOS from 'aos'
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/scss/pagination";
import "swiper/css/navigation";

// Components
import Loader from "../Loader";
import { SkySec } from "../BgAnimation";
import BtnSumate from "../BtnSumate";
import WorksCarousel, { ModalImage } from "../WorksCarousel"
import ImageDesc from "../ImageDesc"
import SolutionChar from "../SolutionChar";
import ImageCarousel from "../ImageCarousel";
import ReviewCarousel from "../ReviewCarousel";
import TitleAnimate from "../TitleAnimate";
import Map from "../Map";
import ScrollAnimation from "../ScrollAnimation";

// Context
import { ModalContext } from "../../contexts/modalContext";
import { ResponseSolutions } from '../types/api'
import { useApi } from '../../config/state'
import { changeDataApi } from '../../config/changeDataApi'

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

export const Solution = ({ data: drupalData, setLoading, loading }: SolutionCmp) => {
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)
    const sectionRef = React.useRef(null)    
    const [tabActivated, setTabActivated] = React.useState<number>(0)

    const [data, setData] = React.useState(drupalData)

    // ==================== api ======================= //
    const dataApi = useApi<ResponseSolutions>(state => state.data)
    const fetchApi = useApi<ResponseSolutions>(state => state.fetchApi)

    React.useEffect(() => {
        fetchApi()
    }, [])

    React.useEffect(() => {
        if (Object.entries(dataApi).length === 0) return;
        const page = drupalSettings.react.nodo.title
        const index = page.includes('Calera') ? 2 : 1

        const newData = changeDataApi(dataApi, index)
        setData(newData)
    }, [dataApi])
    // =================+= end api ==================== //

    // Modal Image
    const [isVisbleModal, setIsVisbleModal] = React.useState<boolean>(false)
    const [currentCard, setCurrentCard] = React.useState<boolean>({ url: '', alt: '' })

    const toggleModal = (visible: boolean, imageData?: object): void => {
        setIsVisbleModal(visible)
        if (imageData) setCurrentCard(imageData)
    }

    const renderComponent = (section: SolutionSection) => {
        switch (section.type) {
            case 'inf_img':
                return <ImageDesc data={section} />
            case 'cards':
                return <WorksCarousel data={section} />
            case 'charts':
                return <SolutionChar data={section} />
            case 'images':
                return <ImageCarousel data={section} />
            case 'reviews':
                return <ReviewCarousel data={section} />
            case 'map':
                return <Map data={section} />
            default:
                return <h1>Elemento aun no creado</h1>
        }
    }

    const changeTab = (e) => {
        let indexTab = e.target.dataset.tab || e.target.parentNode.dataset.tab
        setTabActivated(indexTab)
        removeClass()
    }

    const onSwiperChangeMob = (indexTab) => {
        if ((window.matchMedia("(max-width: 623px)").matches)) {
            setTabActivated(indexTab)
            removeClass()
        }
    }

    const removeClass = (): void => {
        let animatedSections = document.querySelectorAll('.solution-container .aos-animate')
        for (let i = 0; i < animatedSections.length; i++) {
            if (i != 0) animatedSections[i].classList.remove('aos-animate')
        }
        AOS.refresh()
    }

    React.useEffect(() => {
        window.onload = function () {
            setLoading(false)
        }
    }, []);

    return (
        <main className='solution-container'>
            <ModalContext.Provider value={{ isVisbleModal, currentCard, toggleModal }}>
                <div className={`page__banner`}>
                    <SkySec desk={data.img_top_desk} mobile={data.img_top_mob} />
                    {/* <Bird /> */}
                    {data.title.toLowerCase().includes('apan') ?
                        <img className='af-bg__cows' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/vacas.gif`} alt="" title="" /> :
                        <img className='af-bg__farmers' src={`/${THEMEURL}/sources/dist/assets/images/general/background/tierra/agricultores.gif`} alt="" title="" />}
                    <div className="page__banner-title">
                        <h1><TitleAnimate text={!loading ? data.title : ''} /></h1>
                        {!loading && <p className="page__banner-description" dangerouslySetInnerHTML={{ __html: data.desc_head }} data-aos='fade-up' data-aos-delay='2000'></p>}
                    </div>
                    <div className="page__banner-sumate">
                        {!loading && <BtnSumate />}
                    </div>
                    {!loading && <ScrollAnimation delay={2500} />}
                </div>
                <section className='solution__body'>
                    <div className='solution-tab' data-aos='fade-right'>
                        <h3 className="solution-tab__title" data-aos="fade-up">{window.currentLang == 'es' ? 'Dale clic al pilar que quieras conocer' : 'Click on the pillar you want to know more about'}</h3>
                        <Swiper
                            id='tabSolution'
                            modules={[Navigation]}
                            navigation={{
                                prevEl: navigationPrevRef.current,
                                nextEl: navigationNextRef.current,
                            }}
                            slidesPerView={1}
                            breakpoints={{
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                1024: {
                                    slidesPerView: 4,
                                    spaceBetween: 20,
                                },
                                1280: {
                                    slidesPerView: 5,
                                    spaceBetween: 20,
                                },
                            }}
                            onSlideChange={(swiper) => {
                                onSwiperChangeMob(swiper.activeIndex)
                            }}
                            onSwiper={(swiper) => {
                                // Delay execution for the refs to be defined
                                setTimeout(() => {
                                    // Override prevEl & nextEl now that refs are defined
                                    swiper.params.navigation.prevEl = navigationPrevRef.current
                                    swiper.params.navigation.nextEl = navigationNextRef.current

                                    // Re-init navigation
                                    swiper.navigation.destroy()
                                    swiper.navigation.init()
                                    swiper.navigation.update()
                                })
                            }}>
                            {data.tabs.sort((a, b) => a.position - b.position).map(({ title, icon }: SolutionTabs, indexTab: number) => (
                                <SwiperSlide key={indexTab}>
                                    <div className={`solution-tab__item${indexTab == tabActivated ? ' active' : ''}`} data-tab={indexTab} onClick={changeTab}>
                                        <img className='solution-tab__image' src={icon.url} alt={icon.alt} title={icon.alt} width='78' height='78' />
                                        <div className='solution-tab__button'>{title}</div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div ref={navigationPrevRef} className="swiper-button-prev" />
                        <div ref={navigationNextRef} className="swiper-button-next" />
                    </div>
                    <div className="solution__section-container">
                        {data.tabs[tabActivated].sections.map((section: SolutionSection, indexSection: number) => (
                            section.type &&
                            < section ref={sectionRef} key={indexSection}
                                className={`solution__section${section.type == 'inf_img' && section.image_position == 'Arr' ? ' solution__section--half' : ''}`}>
                                {renderComponent(section) }
                            </section>
                        ))}
                    </div>
                </section>
                <ModalImage />
            </ModalContext.Provider>
        </main >
    )
}

export default Loader(Solution)
